import { useQuery } from '@tanstack/react-query';
import getRequestApprovalType from 'Api/reschedule/getRequestApprovalType';
import getRequestApprovalTypeResponse from './model/response/getRequestApprovalTypeResponse';

const useGetRequestApprovalType = () => {
  return useQuery({
    queryKey: ['request-approval-type'],
    queryFn: async () => {
      const response = await getRequestApprovalType();

      return getRequestApprovalTypeResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetRequestApprovalType;
